<template>
  <div class="nav-background">

     <!--------------------------full size menu----------------------------->
     <v-app-bar
         v-if="!hamburger_menu"
         :app="app_val"
         id="site-menu"
         elevation="0"
         :dark="dark"
         dense
     >

        <div
            v-for="(item, i) in items"
            :key="i">

           <!---------- submenu --------------------------------->
           <template v-if="item.sub_items">

              <v-menu offset-y open-on-hover >
                 <template v-slot:activator="{ on, attrs }">
                    <v-btn text    v-bind="attrs" v-on="on">
                       {{ item.name }}
                    </v-btn>
                 </template>

                 <div>
                    <div
                        v-for="(subitem, i) in item.sub_items"
                        :key="'sub'+i"
                        class="link-box"
                    >

                       <!--<v-btn :to="subitem.to" :href="subitem.href">-->
                       <!--   {{subitem.name}}-->
                       <!--</v-btn>-->

                       <router-link v-if="subitem.to"
                           :to="subitem.to" class="link" :target="subitem.target">
                          <div style="width: 100%">
                             {{subitem.name}}
                          </div>

                       </router-link>
                       <a v-else
                          :href="subitem.href" class="link" :target="subitem.target"
                       >
                          <div style="width: 100%">
                          {{subitem.name}}
                          </div>
                       </a>
                    </div>


                 </div>
              </v-menu>
           </template>



           <!-----------render basic button--------------------->
           <template v-else>
              <v-btn
                  v-if="item.to"
                  text
                  :to="item.to"
              >
                 <span >{{ item.name }}</span>
              </v-btn>

              <v-btn
                  v-else
                  text
                  :href="item.href"
              >
                 <span >{{ item.name }}</span>
              </v-btn>
           </template>

        </div>


        <v-spacer/>

        <v-btn text @click="en_mode">English</v-btn>

     </v-app-bar>












    <!--------------------------hamburger menu----------------------------->
    <v-app-bar
            v-else
            :app="app_val"
            id="site-menu"
            elevation="0"
            :dark="dark"


    >
      <!--<a href="/">-->
        <!--<img src="../assets/images/logo/espy-logo-dark-bg.svg" width="200px">-->
      <!--</a>-->

      <!--<span class="pa-3"></span>-->

      <v-spacer></v-spacer>

      <v-menu
              bottom
              origin="center center"
              transition="scale-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn
                  icon
                  v-on="on"
          >
            <v-icon>menu</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
                  v-for="(item, i) in items"
                  :key="i"
          >
            <v-list-item-title>
              <v-btn v-if="item.url" text :to="item.url">{{ item.name }}</v-btn>
              <v-btn v-else text :href="item.href">{{ item.name }}</v-btn>
              </v-list-item-title>
          </v-list-item>


        </v-list>
      </v-menu>
    </v-app-bar>






  </div>

</template>


<style scoped>
.nav-background{
    background-color: rgba(52, 24, 24, 1);
}


  #site-menu{
  background: none;
  /*   background-color: #2196F3;*/
  }

  /*.link-active{*/
  /*  background-color: #2196F3;*/
  /*}*/



  .link-box{
      padding: 5px 10px 5px 10px;
      background-color: white;
  }
  .link-box:hover{
      background-color: var(--color-highlight-primary);
  }

  .link{
      text-decoration: none;
      color: #3e3e3e;
      font-weight: 500;
      font-size: 14pt;
      width: 100%;

  }



</style>
<script>
export default {
  name: 'NavBarJp',
   props:{
     app: Boolean,
      dark: {type: Boolean, default: false}
   },

  data: () => ({
     show_menu: false,


     items: [
        {name: 'ホーム', to: '/jp/home'}, //home

        //radio
        {
           name: 'ラジオ', to: '/jp/radio',
        },
        {
           name: 'ビデオ ',  //videos
           sub_items:[
              {name: 'ドクター波平のお話', to: '/jp/video/namihira-story'},
              {name: '宇宙の闘争', to: '/jp/video/cosmic-conflict'},
              {name: '世の終りの諸事件', to: '/jp/video/final-events'},
              {name: '暗黒の中のランプ', to: '/jp/video/lamp-in-dark'},
              {name: '黙示録、花嫁、獣、そして、バビロン', to: '/jp/video/bride-beast-babylon'},
              {name: '各時代の王国', to: '/jp/video/kingdom-in-time'},
              {name: '預言の中のUSA とローマ', to: '/jp/video/rome-in-prophecy'},

              {name: ' 預言の道しるべ', to: '/jp/video/landmarks-prophecy'},
              {name: '最善の生活', to: '/jp/video/life-at-its-best'},
              {name: 'エルバートンの暗い雲', to: '/jp/video/dark-clouds-over-elberton'},

               //old links
              // {name: '驚くべき発見', href: 'http://amazingdiscoveries.tv/c/208/Total_Onslaught_-_Japanese/', target: '_blank'},
              // {name: '創世記論争', href: 'https://amazingdiscoveries.tv/c/307/Genesis_Conflict_-_Japanese/', target: '_blank'},
              // {name: '最善の生活', href: 'https://amazingdiscoveries.tv/c/320/Life_at_its_Best_-_Japanese/', target: '_blank'},

              // {name: '日本語でご利用いただけます', href: 'https://www.youtube.com/channel/UCmVD5Et3t-S55aG-HMuIZ8A', target: '_blank'},
              {name: '全猛将', href: 'https://www.youtube.com/playlist?list=PLbEbzwhcqeoOvUj9EkTgzbKtlpfRs8nre', target: '_blank'}, //total onslaught
              {name: '創造論争', href: 'https://www.youtube.com/playlist?list=PLbEbzwhcqeoPAs-WUibj09VkSau-jgwnB', target: '_blank'}, //GENESIS CONFLICT
              {name: '最善の生活 ', href: 'https://www.youtube.com/playlist?list=PLbEbzwhcqeoPSYQHajdCFRvw0akdjAJ5h', target: '_blank'}, //LIFE AT THE BEST
              
              {name: '石のなぞなぞ', href: 'https://www.youtube.com/watch?v=_R_6nR8GMLI', target: '_blank'}, //RIDDLES IN STONE

              {name: '新アトランタㇲ', href: 'https://www.youtube.com/watch?v=M6QEdW7UhhY', target: '_blank'}, //THE NEW ATLANTIS
              {name: 'フエニックスの目', href: 'https://www.youtube.com/watch?v=1VSljIhreo4', target: '_blank'}, //EYE OF THE PHOENIX
              {name: 'いったい何をまいているのだ？', href: 'https://www.youtube.com/watch?v=xbCxBtsPXUk', target: '_blank'}, //What in the world are they spraying?
           ]
        },
        {
           name: 'その他', //other
           sub_items: [
              {name: '聖書研究', to: '/jp/bible-study'},
           ]
        },

        {name: '私たち', to: '/jp/about-us'},
        {name: '連絡先', to: '/jp/contact-us'},



     ]

  }),
   methods:{
      toggle_menu(){
         if (['xs', 'sm'].includes(this.$vuetify.breakpoint.name)){
            this.show_menu=false;
            return;
         }

         this.show_menu = !this.show_menu;

      },

      en_mode(){
         this.$store.commit('update_lang', 'en');
         this.$router.push('/');
      },


   },

   computed:{


     hamburger_menu(){
        return (['xs', 'sm'].includes(this.$vuetify.breakpoint.name));
     },

      app_val()
      {
         if (this.app !== undefined)
            return this.app;
         else return false;
      }
   },

   created(){
     // console.log(this.$vuetify.breakpoint)

     // console.log('baseurl', window.location)

   }
};
</script>
